<template>
    <div class="float_card_div">
        <router-link :to="{name: 'user', params: {id: 1257071}}"
                     tag="a"
                     class="float_card_a"
        >
            <img :src="'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'" class="float_card_img">
            <div class="float_card_text_div">
                <p class="float_card_text_p"> 水浒传 </p>
                <p class="float_card_text_p float_card_text_information"> 《水浒传》的故事源起于北宋宣和年间，出现了话本《大宋宣和遗事》描述了宋江、吴加亮（吴用）、晁盖等36人起义造反的故事，成为《水浒传》的蓝本。《水浒传》的故事源起于北宋宣和年间，出现了话本《大宋宣和遗事》描述了宋江、吴加亮（吴用）、晁盖等36人起义造反的故事，成为《水浒传》的蓝本。</p>
            </div>
        </router-link>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        data: {
            type: Object,
            require: true
        }
    }
}
</script>

<style type="text/css" scoped>
.float_card_div {
    box-sizing: border-box;
    padding-right: 15px;
    padding-left: 15px;
}

.float_card_a {
    transition: bottom .3s;
    display: block;
    width: 100%;
    /*height: 100%;*/
    box-shadow: 0 1px 2px 0 #ddd;
    position: relative;
    bottom: 0;
}

.float_card_a:hover {
    box-shadow: 0 4px 20px 4px #ddd;
    bottom: 10px;
}

.float_card_img {
    height: 200px;
    width: 100%;

}

.float_card_text_div {
    width: 100%;
    background: #fff;
    height: 250px;

}

.float_card_text_p {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding: 30px 0 15px;
    font-size: 18px;
    color: #666;
}

.float_card_text_information {
    padding: 0 0 15px;
    font-size: 14px;
    color: #a4a4a4;
}

</style>






